import { useState } from "react";
import { Bluetooth, WIFI } from "../../icons/Icon";
import InputTag from "../FormComponents/InputTag";
import ToggleBtn from "../FormComponents/ToggleBtn";
import styles from "./Printers.module.css";

const IPSetter = ({ mode, header, value, setValue, fieldKey }) => {
  const [error, setError] = useState("");

  const isValidIP = (ip) => {
    const ipRegex =
      /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;
    return ipRegex.test(ip);
  };

  const handleChange = (e) => {
    const newValue = e.target.value;
    setValue((prev) => ({
      ...prev,
      [fieldKey]: newValue,
    }));

    if (newValue === "" || isValidIP(newValue)) {
      setError(""); // Clear error
    } else {
      setError("Invalid IP address");
    }
  };

  return (
    <div
      className={styles.printer}
      style={mode ? { backgroundColor: "#232529", borderColor: "#232529" } : {}}
    >
      <div>
        <p style={{ color: mode && "#FFFFFF" }}>{header}</p>
        <div className={styles.icon_con}>
          <div>
            <WIFI color={mode ? "#FFFFFF" : "#646B88"} />
          </div>
          <ToggleBtn showOnOff={false} status={""} />
          <div>
            <Bluetooth color={mode ? "#FFFFFF" : "#646B88"} />
          </div>
        </div>
      </div>

      <div className={styles.input_con}>
        <InputTag
          padding={"8px"}
          fontSize={"12px"}
          labelText={"Printer's IP"}
          placeholderText={""}
          placeholderType={"text"}
          value={value[fieldKey]}
          onChange={handleChange}
          maxLength={100}
          required={true}
          star
        />
        {error && <span>{error}</span>}
      </div>
    </div>
  );
};

export default IPSetter;
